function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "delete");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "delete",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "filter"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#C3C3C3",
  strokeWidth: 0.3,
  fill: "#FFFFFF",
  cx: 8.5,
  cy: 8.5,
  r: 8.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.25714286,8.25714286 L8.25714286,4.12857143 C8.25714286,3.99444513 8.3658737,3.88571429 8.5,3.88571429 C8.6341263,3.88571429 8.74285714,3.99444513 8.74285714,4.12857143 L8.74285714,8.25714286 L12.8714286,8.25714286 C13.0055549,8.25714286 13.1142857,8.3658737 13.1142857,8.5 C13.1142857,8.6341263 13.0055549,8.74285714 12.8714286,8.74285714 L8.74285714,8.74285714 L8.74285714,12.8714286 C8.74285714,13.0055549 8.6341263,13.1142857 8.5,13.1142857 C8.3658737,13.1142857 8.25714286,13.0055549 8.25714286,12.8714286 L8.25714286,8.74285714 L4.12857143,8.74285714 C3.99444513,8.74285714 3.88571429,8.6341263 3.88571429,8.5 C3.88571429,8.3658737 3.99444513,8.25714286 4.12857143,8.25714286 L8.25714286,8.25714286 Z",
  id: "Combined-Shape",
  fill: "#CDCDCD",
  transform: "translate(8.500000, 8.500000) rotate(45.000000) translate(-8.500000, -8.500000) "
})));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.cbcad47f.svg";
export { ForwardRef as ReactComponent };